module.exports = __webpack_public_path__ + "img/icm-logo.a7ef2444.svg";